import * as THREE from "three";

import { MapControls } from "three/examples/jsm/controls/OrbitControls.js";
import {DefaultDeviceHandler} from "./default_device_handler";


export class ThreeGeneralBuilderHandler extends DefaultDeviceHandler {

	constructor() {
		super();
		this.setupListeners();
	}

	setupListeners() {
		document.addEventListener('keydown', (e) => this.onKeyDown(e));
		document.addEventListener('keyup', (e) => this.onKeyUp(e));
	}

	onKeyDown(event) {
		// console.log('testing::event', event)
		switch (event.code) {
			case 'AltLeft':
				console.log('testing::shiftleft')
				this.deviceControls.screenSpacePanning = true;
				break;
		}
	};

	onKeyUp(event) {
		switch (event.code) {
			case 'AltLeft':
				this.deviceControls.screenSpacePanning = false;
				break;
		}
	};

	bindControls(camera, domElement, scene) {
		camera.rotateX(Math.PI / 180);
		const cpos = camera.position.clone()

		this.deviceControls = new MapControls(camera, domElement);

		this.deviceControls.panSpeed = 6;
		this.deviceControls.minDistance = 15
		this.deviceControls.maxDistance = 30;
		this.deviceControls.maxPolarAngle = Math.PI / 1.5

		this.deviceControls.target.set(cpos.x, cpos.y, cpos.z +1)

		this.deviceControls.mouseButtons = {
			LEFT: null,
			MIDDLE: THREE.MOUSE.ROTATE,
			RIGHT: THREE.MOUSE.PAN,
		}

		this.deviceControls.update()
		this.deviceControls.minDistance = 0;
		this.deviceControls.update()


		return this.deviceControls;
	}

	getPosition() {
		if (this.target === null)
			return null;

		return this.target.clone()
	}

	getRotation() {
		return 0
	}

	getAngle() {
		return this.deviceControls.getAzimuthalAngle()
	}
}
